//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BackendServices from "@/services/backend-services";
import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";

export default {
  name: "SelectedProductValidation",
  props: ["value"],
  components: {},
  mounted: function () {
    this.storedData = this.value;
    BackendServices.getRawProducts().then((response) => {
      // this.recordsTotal = Number(response.headers["x-total-count"]);
      this.storedProductList = response.data.filter(
        (e) => e.id != this.value.product_id && e.ean != null && e.ready
      );
      this.productList = [...this.storedProductList];
      // this.isLoading = false;
    });

    BackendServices.getProductHierarchyLevels().then(({ data }) => {
      this.hierarchyLevels = data;

      BackendServices.getProductHierarchyLevelElements(
        this.hierarchyLevels[0].id,
        null
      ).then(({ data }) => {
        this.hierarchyLevelElements.push(
          data.filter((e) => e.name != "Sem Categorização" && e.name != null)
        );
        this.storedHierarchyLevelElements = [...this.hierarchyLevelElements];
      });
    });

    this.validateData();
  },
  updated: function () {
    this.$nextTick(function () {
      this.validateData();
    });
  },
  data: () => ({
    validForm: null,
    lastSelectedHierarchyElement: [],
    hierarchyLevels: [],
    hierarchyLevelElements: [],
    storedHierarchyLevelElements: [],
    type: null,
    productList: [],
    storedProductList: [],
    searchColumn: null,
    parentProduct: {
      id: null,
      data: {
        product_retailer_infos: [
          {
            sku: null,
            name: null,
            category_code: null,
            category_description: null,
            subcategory_code: null,
            subcategory_description: null,
            brand: null,
            sub_brand: null,
          },
        ],
      },
      hierarchy: [],
      product_retailer_infos: [{}],
    },
    parentProductRTL: [
      {
        sku: null,
        name: null,
        category_code: null,
        category_description: null,
        subcategory_code: null,
        subcategory_description: null,
        brand: null,
        sub_brand: null,
      },
    ],
    storedData: {
      product_id: null,
      product_name: null,
      sales_volume_factor: null,
      least_hierarchy_level_id: null,
      file_upload_id: null,
      ean: null,
      retailer: {
        id: null,
        name: null,
      },
      product_retailer_infos: {
        product_description: null,
        internal_code: null,
        category_code: null,
        category_description: null,
        subcategory_code: null,
        subcategory_description: null,
        brand: null,
        sub_brand: null,
      },
      type: null,
    },
  }),
  computed: {
    isNew: function () {
      return this.value.id == null || this.value.id == undefined;
    },
  },
  methods: {
    required,
    noValidation,
    hierarchyValidation: function (index) {
      if (!index) {
        return this.required("Campo obrigatório");
      } else {
        return this.noValidation();
      }
    },
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData: function () {
      this.$emit("value", this.value);
    },
    setParentProduct: async function (productId) {
      let operationObject = {};
      operationObject.code = this.storedData.ean;
      operationObject.name = this.storedData.product_name;
      operationObject.retailer_id = this.storedData.retailer.id;
      operationObject.type = "produto";
      let response = await BackendServices.getProduct(productId);
      if (response.data.product_retailer_infos.length > 0) {
        this.parentProductRTL = response.data.product_retailer_infos[0];
      } else {
        this.resetParentProductRTL();
      }
      operationObject.product_id = response.data.id;
      this.$emit("value", operationObject);
      this.setParentProductHierarchy(productId);
    },
    setParentProductHierarchy: async function (productId) {
      let response_hierarchy = await BackendServices.getProductHierarchy(
        productId
      );
      this.parentProduct.hierarchy = response_hierarchy.data;
    },
    getHierarchyList(index, level, parentId) {
      if (level === undefined) {
        let exportObj = { ...this.value };
        exportObj.least_hierarchy_level_id =
          this.lastSelectedHierarchyElement[index - 1];
        exportObj.type = "product";
        this.$emit("value", exportObj);
      }
      if (level) {
        BackendServices.getProductHierarchyLevelElements(
          level.id,
          parentId
        ).then(({ data }) => {
          this.storedHierarchyLevelElements.splice(index);
          this.hierarchyLevelElements.splice(index);
          this.lastSelectedHierarchyElement.splice(index);
          this.hierarchyLevelElements.push(data);
          this.storedHierarchyLevelElements.push(data);
        });
      }
    },
    filterFnByName(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.productList = this.storedProductList.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
    filterFnByEAN(val, update) {
      update((data = this) => {
        const needle = val;
        data.productList = data.storedProductList.filter((v) =>
          v.ean.includes(needle)
        );
      });
    },
    reCreateStoredValue: function () {
      for (let key in this.storedData) {
        this.value[key] = this.storedData[key];
      }
    },
    resetParentProductRTL: function () {
      this.parentProductRTL = [
        {
          sku: null,
          name: null,
          category_code: null,
          category_description: null,
          subcategory_code: null,
          subcategory_description: null,
          brand: null,
          sub_brand: null,
        },
      ];
    },
  },
  watch: {
    value: {
      handler: function () {
        if (
          this.value.product_id != this.storedData.id &&
          (this.value.type === null || this.value.type === undefined)
        ) {
          this.storedData = this.value;

          this.lastSelectedHierarchyElement = [];
          if (this.hierarchyLevelElements.length > 1) {
            this.hierarchyLevelElements.splice(1);
          }
          if (this.storedHierarchyLevelElements.length > 1) {
            this.storedHierarchyLevelElements.splice(1);
          }

          this.value.type = null;

          this.parentProduct = {
            id: null,
            data: {
              product_retailer_infos: [
                {
                  sku: null,
                  name: null,
                  category_code: null,
                  category_description: null,
                  subcategory_code: null,
                  subcategory_description: null,
                  brand: null,
                  sub_brand: null,
                },
              ],
            },
            hierarchy: [],
            product_retailer_infos: [{}],
          };
        }
      },
    },
    type: {
      handler: function () {
        if (this.type === "existing") {
          this.reCreateStoredValue();

          this.lastSelectedHierarchyElement = [];
          if (this.hierarchyLevelElements.length > 1) {
            this.hierarchyLevelElements.splice(1);
          }
          if (this.storedHierarchyLevelElements.length > 1) {
            this.storedHierarchyLevelElements.splice(1);
          }
        } else if (this.type === "new") {
          this.reCreateStoredValue();

          this.parentProduct = {
            id: null,
            data: {
              product_retailer_infos: [
                {
                  sku: null,
                  name: null,
                  category_code: null,
                  category_description: null,
                  subcategory_code: null,
                  subcategory_description: null,
                  brand: null,
                  sub_brand: null,
                },
              ],
            },
            hierarchy: [],
            product_retailer_infos: [{}],
          };

          this.resetParentProductRTL();
        } else {
          this.reCreateStoredValue();

          this.lastSelectedHierarchyElement = [];
          if (this.hierarchyLevelElements.length > 1) {
            this.hierarchyLevelElements.splice(1);
          }
          if (this.storedHierarchyLevelElements.length > 1) {
            this.storedHierarchyLevelElements.splice(1);
          }

          this.parentProduct = {
            id: null,
            data: {
              product_retailer_infos: [
                {
                  sku: null,
                  name: null,
                  category_code: null,
                  category_description: null,
                  subcategory_code: null,
                  subcategory_description: null,
                  brand: null,
                  sub_brand: null,
                },
              ],
            },
            hierarchy: [],
            product_retailer_infos: [{}],
          };
          this.resetParentProductRTL();
        }
        if (this.type) {
          this.validateData();
        } else {
          this.$emit("form-invalid", false);
        }
        this.$emit("validation-type", this.type);
      },
    },
  },
};
